/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Link} from '@ion/core/src/types/entities';
import {itemsToCSV} from '@ion/core/src/utils/StringUtil';

export interface SubGroupCellType {
  data: {
    subAccounts: Link[]
  };
}

export const SubGroupCell = ({data}: SubGroupCellType) => (
  <div>{itemsToCSV(data?.subAccounts, 'title')}</div>
);

export default SubGroupCell;
